const isWindowsPhone = (): boolean => {
  return /(?:Windows Phone)/.test(navigator.userAgent);
};

export default isWindowsPhone;
